module.exports = __webpack_public_path__ + "img/Group-32711-1-1.cf3d182f.png";